import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import PlanServices from '../../services/PlanServices';
import CategoryServices from '../../services/CategoryServices';
import Select from "react-select";
import useAsync from '../../hooks/useAsync';

function PlanUpdate({ plan, closeModal, onSuccess }) {
  const { data } = useAsync(CategoryServices.getCategory);
  console.warn(data.data);
  const [formValues, setFormValues] = useState({
    planType: '',
    planName: '',
    mainAmount: null,
    offerPrice: null,
    noOfMonth: null,
    termsAndConditions: "",
    percentageOrderAmount: null,
    numberOfBookings: null,
    discountAmount: null,
    totalServices: null,
    numberOfBookingsParMonth: null,
    benefits: [],
    category: [],
  });
  const [benefitInput, setBenefitInput] = useState(''); 

  useEffect(() => {
    if (plan) {
      setFormValues({
        planType: plan?.planType || '',
        planName: plan?.planName || '',
        mainAmount: plan?.mainAmount || '',
        offerPrice: plan?.offerPrice || '',
        noOfMonth: plan?.noOfMonth || '',
        termsAndConditions: plan?.termsAndConditions || '',
        percentageOrderAmount: plan?.percentageOrderAmount || '',
        numberOfBookings: plan?.numberOfBookings || '',
        discountAmount: plan?.discountAmount || '',
        totalServices: plan?.totalServices || '',
        numberOfBookingsParMonth: plan?.numberOfBookingsParMonth || '',
        benefits: plan?.benefits || [],
        category: plan?.category || [],
      });
    }
  }, [plan]);

  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;
  //   setFormValues({
  //     ...formValues,
  //     [name]: value,
  //   });
  // };



  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const updatedValues = {
      ...formValues,
      [name]: value,
    };

    if (name === "noOfMonth" && (value < 1 || value > 12)) {
      alert("Please enter a valid month between 1 and 12.");
      return;
    }

    if (name === "discountAmount") {
      const numValue = parseFloat(value);
      if (!Number.isInteger(numValue)) {
        const nearestWhole = Math.round(numValue);
        alert(`Please enter a whole number. The nearest valid values are ${nearestWhole - 1} and ${nearestWhole + 1}`);
        return;
      }
      if (numValue < 0) {
        alert("Discount amount cannot be negative");
        return;
      }
    }

    if ((name === "mainAmount" || name === "offerPrice") &&
      updatedValues.mainAmount && updatedValues.offerPrice) {
      const mainAmount = parseFloat(updatedValues.mainAmount);
      const offerPrice = parseFloat(updatedValues.offerPrice);

      if (!isNaN(mainAmount) && !isNaN(offerPrice) && mainAmount > 0) {
        const discountPercent = ((mainAmount - offerPrice) / mainAmount) * 100;
        updatedValues.discountAmount = Math.round(discountPercent);
      }
    }


    setFormValues(updatedValues);
  };


  const handleMultiSelectChange = (selectedOptions) => {
    setFormValues({
      ...formValues,
      category: selectedOptions.map((option) => option.value),
    });
  };

  const categoryOptions = data?.data?.map((cat) => ({
    value: cat._id,
    label: cat.title,
  })) || [];



  const handleBenefitChange = (index, event) => {
    const updatedBenefits = formValues.benefits.map((benefit, i) =>
      i === index ? event.target.value : benefit
    );
    setFormValues({
      ...formValues,
      benefits: updatedBenefits,
    });
  };

  const addBenefit = () => {
    setFormValues({
      ...formValues,
      benefits: [...formValues.benefits, ''],
    });
  };


  const removeBenefit = (index) => {
    const updatedBenefits = formValues.benefits.filter((_, i) => i !== index);
    setFormValues({
      ...formValues,
      benefits: updatedBenefits,
    });
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; 
  };

  const validateForm = () => {
    const { mainAmount, offerPrice, startDate, endDate } = formValues;

    if (new Date(startDate) >= new Date(endDate)) {
      alert('End Date must be later than Start Date.');
      return false;
    }

    if (parseFloat(offerPrice) >= parseFloat(mainAmount)) {
      alert('Offer Price must be less than the Main Amount.');
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return
    try {
      const formData = new FormData();
      for (const key in formValues) {
        if (key === 'benefits') {
          formValues.benefits.forEach((benefit) => formData.append('benefits[]', benefit));
        } else {
          formData.append(key, formValues[key]);
        }
      }

      await PlanServices.updatePlan(plan.id, formValues);
      alert('Plan updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update plan', error);
      alert(error.response?.data?.message || 'Failed to add plan details');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Edit Plan</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                  <div className="row">

                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Plan Name<span className="red">*</span></label>
                      <input
                        type="text"
                        name="planName"
                        className="form-control"
                        value={formValues.planName}
                        onChange={handleInputChange}
                        placeholder="Plan Name"
                        
                      />
                    </div>
                  </div>



                 <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Amount<span className="red">*</span></label>
                      <input
                        type="number"
                        name="mainAmount"
                        className="form-control"
                        value={formValues.mainAmount}
                        onChange={handleInputChange}
                        placeholder="Enter Amount"
                        min="0"
                        step="0"
                        
                      />
                    </div>
                  </div>


                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Month<span className="red">*</span></label>
                      <select
                        name="noOfMonth"
                        className="form-control"
                        value={formValues.noOfMonth}
                        onChange={handleInputChange}
                        
                      >
                        <option value="" disabled>Select Month</option>
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={i + 1}>{i + 1}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Offer Price<span className="red">*</span></label>
                      <input
                        type="number"
                        name="offerPrice"
                        className="form-control"
                        value={formValues.offerPrice}
                        onChange={handleInputChange}
                        placeholder="Enter Offer Price"
                        min="0"
                        step="0"
                        
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Benefits<span className="red">*</span></label>
                      {formValues.benefits.map((benefit, index) => (
                        <div key={index} className="input-group mb-2">
                          <input
                            type="text"
                            className="form-control"
                            value={benefit}
                            onChange={(event) =>
                              handleBenefitChange(index, event)
                            }
                            placeholder="Benefit description"
                            
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => removeBenefit(index)}
                            >
                              &times;
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-secondary mt-2"
                        onClick={addBenefit}
                      >
                        + Add Benefit
                      </button>
                    </div>
                  </div>


                  {formValues.planType === "Fixed" && (
                    <>

                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Discount Amount (%)<span className="red">*</span></label>
                          <input
                            type="number"
                            name="discountAmount"
                            className="form-control"
                            value={formValues.discountAmount}
                            onChange={handleInputChange}
                            placeholder="Enter whole number percentage"
                            min="0"
                            step="1"  
                            
                          />
                          {formValues.discountAmount % 1 !== 0 && (
                            <div className="error-message">
                              Please enter a whole number. Nearest values: {Math.floor(formValues.discountAmount)} and {Math.ceil(formValues.discountAmount)}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Total Number of Services<span className="red">*</span></label>
                          <input
                            type="number"
                            name="totalServices"
                            className="form-control"
                            value={formValues.totalServices}
                            onChange={handleInputChange}
                            placeholder="Enter Total Number of Services"
                            min="1"
                            
                          />
                        </div>
                      </div>


                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Total Number of Services Par Month<span className="red">*</span></label>
                          <input
                            type="number"
                            name="numberOfBookingsParMonth"
                            className="form-control"
                            value={formValues.numberOfBookingsParMonth}
                            onChange={handleInputChange}
                            placeholder="Enter Total Number of Services Par Month"
                            min="1"
                            
                          />
                        </div>
                      </div>


                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Select Category<span className="red">*</span></label>
                          <Select
                            options={categoryOptions}
                            isMulti
                            name="category"
                            value={
                              categoryOptions.length > 0 && formValues.category
                                ? categoryOptions.filter((opt) =>
                                  formValues.category.includes(opt.value)
                                )
                                : []
                            }
                            onChange={handleMultiSelectChange}
                            placeholder="Select categories..."
                          />

                        </div>
                      </div>


                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Terms and Conditions<span className="red">*</span></label>
                          <textarea
                            name="termsAndConditions"
                            className="form-control h-auto"
                            value={formValues.termsAndConditions}
                            onChange={handleInputChange}
                            placeholder="Enter terms and conditions"
                            
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {formValues.planType === "Percentage" && (
                    <>
                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Discount Amount<span className="red">*</span></label>
                          <input
                            type="number"
                            name="discountAmount"
                            className="form-control"
                            value={formValues.discountAmount}
                            onChange={handleInputChange}
                            placeholder="Enter Discount Amount"
                            min="0"
                            step="0"
                            
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Percentage of Order Amount<span className="red">*</span></label>
                          <input
                            type="number"
                            name="percentageOrderAmount"
                            className="form-control"
                            value={formValues.percentageOrderAmount}
                            onChange={handleInputChange}
                            placeholder="Enter Percentage of Order Amount"
                            min="0"
                            step="1"
                            
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Number of Bookings<span className="red">*</span></label>
                          <input
                            type="number"
                            name="numberOfBookings"
                            className="form-control"
                            value={formValues.numberOfBookings}
                            onChange={handleInputChange}
                            placeholder="Enter Number of Bookings"
                            min="1"
                            
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Terms and Conditions<span className="red">*</span></label>
                          <textarea
                            name="termsAndConditions"
                            className="form-control h-auto"
                            value={formValues.termsAndConditions}
                            onChange={handleInputChange}
                            placeholder="Enter terms and conditions"
                            
                          />
                        </div>
                      </div>
                    </>
                  )}
                  
                </div>
                    <button type="submit" className="submit-green-btn">Update</button>
                  </form>
                </div>


                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlanUpdate;
